import React from 'react';
import PropTypes from 'prop-types';
import {utils, writeFile} from 'xlsx';
import Alert from "@mui/material/Alert";
import AlertTitle from "@mui/material/AlertTitle";
import {isEmpty, extractWorkSheetData, formatDate, ExcelDateToDateString} from "../../globals/GlobalFunctions";


export interface Props {
    excelData: any;
}

//excel format
function HealthbusFormatter ({excelData}: Props) {
    //console.log(excelData, "DING");
    const [successAlert, setSuccessAlert] = React.useState(false);
    const [errorAlert, setErrorAlert] = React.useState(false);
    try {
        //Check for data and that there is a sheet in the data named Census
        if (!isEmpty(excelData) && excelData.Sheets.Healthbus !== undefined) {

            //global function to extract the data into a sequential array of cell data values as well as the column and row ranges
            let sheetDataArray = extractWorkSheetData(excelData.Sheets.Healthbus);

            let rawCellArray: any[] = sheetDataArray[0];

            let columnRange: number = sheetDataArray[1];

            let rowRange: number = sheetDataArray[2];

            const valuesIndexCollection = {
                relationshipTypeIndex: rawCellArray.indexOf('Relationship Type') + 1,
                fnIndex: rawCellArray.indexOf('Member First Name') + 1,
                mnIndex: rawCellArray.indexOf('Member Middle Name') + 1,
                lnIndex: rawCellArray.indexOf('Member Last Name') + 1,
                planIDIndex: rawCellArray.indexOf('Plan ID') + 1,
                divisionIndex: rawCellArray.indexOf('Division ID') + 1,
                dobIndex: rawCellArray.indexOf('Member Date of Birth') + 1,
                altIndex: rawCellArray.indexOf('Member Alternate ID') + 1,
                emailIndex: rawCellArray.indexOf('Member Email Address') + 1,
                addIndex: rawCellArray.indexOf('Member Address') + 1,
                add2Index: rawCellArray.indexOf('Member Address 2') + 1,
                cityIndex: rawCellArray.indexOf('Member City') + 1,
                stateIndex: rawCellArray.indexOf('Member State') + 1,
                zipIndex: rawCellArray.indexOf('Member Zip Code') + 1,
                sexIndex: rawCellArray.indexOf('Member Gender') + 1,
                enrollDateIndex: rawCellArray.indexOf('Effective Date') + 1,
                disenrollDateIndex: rawCellArray.indexOf('Termination Date') + 1,
                groupIndex: rawCellArray.indexOf('Group ID') + 1,
                memberSequenceIndex: rawCellArray.indexOf('Member Sequence') + 1,
                subscriberIDIndex: rawCellArray.indexOf('Subscriber ID') + 1,
                tierIndex: rawCellArray.indexOf('Tier') + 1,
                memberSSNIndex: rawCellArray.indexOf('Member SSN') + 1,
                planIndex: rawCellArray.indexOf('Plan') + 1,
                phoneIndex: rawCellArray.indexOf('Member Home Phone') + 1,
            }

            let arrayOfMemberArrays: any[] = [[
                "Date of Eligibility Data", "Time of Eligibility Data", "Client ID", "Client Name", "Vendor ID", "Vendor Name", "Payer ID", "Payer Name", "TPA / Broker ID",
                "TPA/Broker Name", "Transaction ID", "Subscriber", "HIPAA Relationship Code", "Is Dependent Over 26", "Date of Death", "Subscriber ID", "Group ID",
                "Location ID / Division ID", "Effective Date", "Termination Date", "Coverage Code", "First Name", "Last Name", "Middle Name", "Name Suffix", "SSN", "Email Address", "Home Phone",
                "Address 1", "Address 2", "City", "State", "Zip Code", "Country ID", "Country Code", "Country Name", "Date of Birth", "Gender", "Marital Status", "Ethnicity Code",
                "Plan-1 Type", "Plan-1 Description", "Plan-1 HIPAA Tier", "Plan-1 Start Date", "Plan-1 End Date", "Plan-1 ID", "Plan-2 Type", "Plan-2 Description",
                "Plan-2 HIPAA Tier", "Plan-2 Start Date", "Plan-2 End Date", "Plan-2 ID"
            ]];

            for (let i = 1; i < rowRange; i++) {
                //our member to later be pushed. Oh from what humble origins it begins
                let memberArray: any[] = [];
                //for each new member array we skip over the previous members determined by the column length, removing 1 to account for our zero based index at the beginning
                let rowMultiplier = columnRange * i - 1;

                let today = new Date();

                const month = today.getMonth() + 1;

                let monthString = "";

                let dayString = "";

                if(month < 10){
                    monthString = "0" + month.toString();
                }
                else{
                    monthString = month.toString();
                }

                const day = today.getDate();

                if(day < 10) {
                    dayString = "0" + day.toString();
                }
                else {
                    dayString = day.toString();
                }

                const year = today.getFullYear().toString();

                let termDate = new Date(Math.round((rawCellArray[(rowMultiplier + valuesIndexCollection.disenrollDateIndex)] - 25568)*86400*1000));

                //exclude terms and expense
                if (termDate > today && rawCellArray[(rowMultiplier + valuesIndexCollection.lnIndex)].toString().toUpperCase() != "EXPENSE") {

                    memberArray.push(year + monthString + dayString);

                    memberArray.push("", "", "", "", "", "", "", "", "CAS", "");

                    //is subscriber?
                    if (valuesIndexCollection.memberSequenceIndex > 0 && rawCellArray[(rowMultiplier + valuesIndexCollection.memberSequenceIndex)].toString() === "01") {
                        memberArray.push("Y");
                    } else {
                        memberArray.push("N");
                    }

                    //HIPAA Codes
                    if (valuesIndexCollection.relationshipTypeIndex > 0) {
                        switch (rawCellArray[(rowMultiplier + valuesIndexCollection.relationshipTypeIndex)]) {
                            case "Subscriber":
                                memberArray.push("18");
                                break;
                            case "Spouse":
                                memberArray.push("01");
                                break;
                            case "Dependent":
                                memberArray.push("19");
                                break;
                        }
                    } else {
                        memberArray.push("");
                    }

                    memberArray.push("", "");

                    //if alt, otherwise sub ID and 01
                    if (valuesIndexCollection.altIndex > 0) {
                        if (rawCellArray[(rowMultiplier + valuesIndexCollection.altIndex)].length > 0) {
                            memberArray.push(rawCellArray[(rowMultiplier + valuesIndexCollection.altIndex)].toString().toUpperCase());
                        } else {
                            if (valuesIndexCollection.subscriberIDIndex > 0) {
                                memberArray.push(rawCellArray[(rowMultiplier + valuesIndexCollection.subscriberIDIndex)].toString().toUpperCase() + "01");
                            }
                        }
                    } else {
                        memberArray.push("");
                    }

                    if(valuesIndexCollection.groupIndex > 0){
                        memberArray.push(rawCellArray[(rowMultiplier + valuesIndexCollection.groupIndex)].toString());
                    } else {
                        memberArray.push("");
                    }

                    if (valuesIndexCollection.divisionIndex > 0) {
                        memberArray.push(rawCellArray[(rowMultiplier + valuesIndexCollection.divisionIndex)].toString().toUpperCase());
                    } else {
                        memberArray.push("");
                    }

                    if (valuesIndexCollection.enrollDateIndex > 0) {
                        let date = rawCellArray[(rowMultiplier + valuesIndexCollection.enrollDateIndex)].toString();
                        if (date.includes("/")) {
                            date = formatDate(date);
                        } else if (date.length > 0 && date.length < 6) {
                            date = ExcelDateToDateString(date);
                        }

                        memberArray.push(date.toString().toUpperCase());
                    } else {
                        memberArray.push("");
                    }

                    //removes 12/31/2222 date
                    if (valuesIndexCollection.disenrollDateIndex > 0) {
                        let date = rawCellArray[(rowMultiplier + valuesIndexCollection.disenrollDateIndex)].toString();
                        if (date.includes("/")) {
                            date = formatDate(date);
                        } else if (date.length > 0 && date.length < 6) {
                            date = ExcelDateToDateString(date);
                        } else if (date === "117974") {
                            date = "";
                        }

                        memberArray.push(date.toString().toUpperCase());
                    } else {
                        memberArray.push("");
                    }

                    //individual or family
                    if (valuesIndexCollection.tierIndex > 0) {
                        if(rawCellArray[(rowMultiplier + valuesIndexCollection.tierIndex)].toString() === "EM"){
                            memberArray.push("I");
                        }
                        else if(rawCellArray[(rowMultiplier + valuesIndexCollection.tierIndex)].toString() === "ES"){
                            memberArray.push("F");
                        }
                        else if(rawCellArray[(rowMultiplier + valuesIndexCollection.tierIndex)].toString() === "EC"){
                            memberArray.push("F");
                        }
                        else if(rawCellArray[(rowMultiplier + valuesIndexCollection.tierIndex)].toString() === "FA"){
                            memberArray.push("F");
                        }
                    } else {
                        memberArray.push("");
                    }

                    if (valuesIndexCollection.fnIndex > 0) {
                        memberArray.push(rawCellArray[(rowMultiplier + valuesIndexCollection.fnIndex)].toString().toUpperCase());
                    } else {
                        memberArray.push("");
                    }

                    if (valuesIndexCollection.lnIndex > 0) {
                        memberArray.push(rawCellArray[(rowMultiplier + valuesIndexCollection.lnIndex)].toString().toUpperCase());
                    } else {
                        memberArray.push("");
                    }

                    if (valuesIndexCollection.mnIndex > 0) {
                        memberArray.push(rawCellArray[(rowMultiplier + valuesIndexCollection.mnIndex)].toString().toUpperCase());
                    } else {
                        memberArray.push("");
                    }

                    memberArray.push("");

                    if (valuesIndexCollection.memberSSNIndex > 0) {
                        memberArray.push(rawCellArray[(rowMultiplier + valuesIndexCollection.memberSSNIndex)].toString().toUpperCase());
                    } else {
                        memberArray.push("");
                    }

                    if (valuesIndexCollection.emailIndex > 0) {
                        memberArray.push(rawCellArray[(rowMultiplier + valuesIndexCollection.emailIndex)].toString().toUpperCase());
                    } else {
                        memberArray.push("");
                    }

                    if (valuesIndexCollection.phoneIndex > 0) {
                        memberArray.push(rawCellArray[(rowMultiplier + valuesIndexCollection.phoneIndex)].toString().toUpperCase());
                    } else {
                        memberArray.push("");
                    }

                    if (valuesIndexCollection.addIndex > 0) {
                        memberArray.push(rawCellArray[(rowMultiplier + valuesIndexCollection.addIndex)].toString().toUpperCase());
                    } else {
                        memberArray.push("");
                    }

                    if (valuesIndexCollection.add2Index > 0) {
                        memberArray.push(rawCellArray[(rowMultiplier + valuesIndexCollection.add2Index)].toString().toUpperCase());
                    } else {
                        memberArray.push("");
                    }

                    if (valuesIndexCollection.cityIndex > 0) {
                        memberArray.push(rawCellArray[(rowMultiplier + valuesIndexCollection.cityIndex)].toString().toUpperCase());
                    } else {
                        memberArray.push("");
                    }

                    if (valuesIndexCollection.stateIndex > 0) {
                        memberArray.push(rawCellArray[(rowMultiplier + valuesIndexCollection.stateIndex)].toString().toUpperCase());
                    } else {
                        memberArray.push("");
                    }

                    if (valuesIndexCollection.zipIndex > 0) {
                        memberArray.push(rawCellArray[(rowMultiplier + valuesIndexCollection.zipIndex)].toString().toUpperCase());
                    } else {
                        memberArray.push("");
                    }

                    memberArray.push("", "US", "United States");

                    if (valuesIndexCollection.dobIndex > 0) {
                        let date = rawCellArray[(rowMultiplier + valuesIndexCollection.dobIndex)].toString();
                        if (date.includes("/")) {
                            date = formatDate(date);
                        } else if (date.length > 0 && date.length < 6) {
                            date = ExcelDateToDateString(date);
                        }
                        memberArray.push(date.toString().toUpperCase());
                    } else {
                        memberArray.push("");
                    }

                    if (valuesIndexCollection.sexIndex > 0) {
                        let sex = rawCellArray[(rowMultiplier + valuesIndexCollection.sexIndex)].toUpperCase();
                        if(sex === "MALE"){
                            sex = "M";
                        }
                        else if(sex === "FEMALE"){
                            sex = "F";
                        }
                        else if(sex === "UNDEFINED"){
                            sex = "U";
                        }
                        memberArray.push(sex);
                    }
                    else {
                        memberArray.push("");
                    }

                    memberArray.push("", "", "Medical and RX");

                    if (valuesIndexCollection.planIndex > 0) {
                        memberArray.push(rawCellArray[(rowMultiplier + valuesIndexCollection.planIndex)].toString().toUpperCase());
                    } else {
                        memberArray.push("");
                    }

                    memberArray.push("", "", "");

                    if (valuesIndexCollection.planIDIndex > 0) {
                        memberArray.push(rawCellArray[(rowMultiplier + valuesIndexCollection.planIDIndex)].toString().toUpperCase());
                    } else {
                        memberArray.push("");
                    }

                    memberArray.push("", "", "", "", "", "");

                    arrayOfMemberArrays.push(memberArray);
                }
            }

            //sorts subs then dependants, excluding header
            arrayOfMemberArrays.sort(function(a, b) {
                if (a !== arrayOfMemberArrays[0] && b !== arrayOfMemberArrays[0]) {
                    if (a[5] < b[5]) return -1;
                    if (a[5] > b[5]) return 1;
                    return 0;
                }
                else {
                    return 0;
                }
            });

            arrayOfMemberArrays.sort(function(a, b) {
                if (a !== arrayOfMemberArrays[0] && b !== arrayOfMemberArrays[0]) {
                    return Number(a[7]) - Number(b[7]);
                }
                else return 0;
            });

            //create our workbook
            const eligWorkbook = utils.book_new();
            //make the member sheet from our member array of arrays
            let ws1 = utils.aoa_to_sheet(arrayOfMemberArrays, {dateNF: 'mm.dd.yyyy'});

            const today = new Date();

            const month = today.getMonth() + 1;

            let monthString = "";

            let dayString = "";

            if(month < 10){
                monthString = "0" + month.toString();
            }
            else{
                monthString = month.toString();
            }

            const day = today.getDate();

            if(day < 10) {
                dayString = "0" + day.toString();
            }
            else {
                dayString = day.toString();
            }

            const year = today.getFullYear();
            //add it to the new workbook
            utils.book_append_sheet(eligWorkbook, ws1, "Healthbus_Eligibility_" + year + monthString  + dayString);
            //it exists and has a sheet send it back to app for export
            if (eligWorkbook && eligWorkbook.SheetNames.includes("Healthbus_Eligibility_" + year + monthString  + dayString)) {
                if(!eligWorkbook.Props) eligWorkbook.Props = {};

                //setting the workbook title through props
                eligWorkbook.Props.Title = "Healthbus_Eligibility_" + year + monthString  + dayString + ".xlsx";

                //writing the file which will make the download, second param is the name of the file and third is required options
                writeFile(eligWorkbook, "Healthbus_Eligibility_" + year + monthString  + dayString + ".xlsx",{});

                console.log("File Export Complete!");
                setSuccessAlert(true);
            }
            else {
                setErrorAlert(true);
                console.log("Unknown Export Error!");
            }

            //clear it out at the end in case of rerendering
            excelData.Sheets.Healthbus = undefined;
        }
    }
    catch(e) {
            console.log("ERROR", e);

            setErrorAlert(true);
            //clear it out after errors in case of rerendering otherwise the error spams will continue until morale improves
            excelData.Sheets.Healthbus = undefined;
    }
    return (
            <div>
                {successAlert ? <Alert severity='success' onClose={() => setSuccessAlert(false)} variant="filled">
                    <AlertTitle>Success!</AlertTitle>
                    File Download Complete!
                </Alert> : <></> }
                {errorAlert ? <Alert severity='error' onClose={() => setErrorAlert(false)} variant="filled">
                    <AlertTitle>Error!</AlertTitle>
                    There was an error with this file!
                </Alert> : <></> }
            </div>
    );
}

export default React.memo(HealthbusFormatter)

HealthbusFormatter.propTypes = {
    excelData: PropTypes.object.isRequired
};